import React, { useState, useEffect, useReducer, useRef, useMemo } from "react";
import {
  Tabs,
  Tab,
  Grid,
  Box,
  Card,
  IconButton,
  Button,
  Input,
  InputAdornment,
  Typography,
  Stack,
  Tooltip,
  Menu,
  MenuItem,
  Divider,
  List,
  ListItem,
  CircularProgress
} from "@mui/material";
import dayjs from "dayjs";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { get } from "aws-amplify/api";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridRowModes,
  useGridApiRef,
} from "@mui/x-data-grid";
import { I18n } from "@aws-amplify/core";
import { GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import ConfirmDeleteDialog from "popup/ConfirmDeleteDialog";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import currentUserToken from "CurrentUserToken";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import { post } from "aws-amplify/api";
import { APIStatusDialog } from "components/APIStatusDialog";
import EncodeDialog from "popup/EncodeDialog";
import TemplateBox from "components/TemplateBox";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { useLocation } from "react-router-dom";
import { DataGridPro } from "@mui/x-data-grid-pro/DataGridPro";
import NewAccountAssignationDialog from "popup/NewAccountAssignationDialog";
import EncodingSettingsMenu from "../components/EncodingSettingsMenu";
import PatternSettingsMenu from "../components/PatternSettingsMenu";
import EventHistorySettingsMenu from "../components/EventHistorySettingsMenu";
import { itIT } from "@mui/x-data-grid/locales";
import { deDE } from "@mui/x-data-grid/locales";
import ErrorDialog from "popup/ErrorDialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import UnrecMailPopup from "popup/UnrecognizedMailPopup";
import { alarmColumns } from "layouts/dashboard/components/Contacts/columns";
import {
  DarkMode,
  EmailOutlined,
  EmailRounded,
  EmailSharp,
  EmailTwoTone,
  RefreshOutlined,
  EditIcon,
} from "@mui/icons-material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MapEmailPopup from "popup/MapEmailPopup";
import { set } from "date-fns";
const COLUMN_VISIBILITY_KEY = "columnVisibility_unrecognized";


const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function UnrecognizedEmail() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const apiRef = useGridApiRef();
  const [searchText, setSearchText] = useState("");
  const theme = useTheme();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const [languages, setLanguages] = useState([]);
  const toolbarRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [resizeThrottle, setResizeThrottle] = useState(60);
  const [rowModesModel, setRowModesModel] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [loading, setLoading] = useState(false); //State for loading spinner

  useEffect(() => {
    const parentElement = toolbarRef.current;
    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }
    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });
    resizeObserver.observe(parentElement);
    checkSize(parentElement.offsetWidth);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const savedColumnVisibility = localStorage.getItem(COLUMN_VISIBILITY_KEY);
    if (savedColumnVisibility) {
      setColumnVisibilityModel(JSON.parse(savedColumnVisibility));
    } else {
      setColumnVisibilityModel({
        alarm_id: false,
      });
    }
  }, []);

  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(COLUMN_VISIBILITY_KEY, JSON.stringify(newModel));
  };

  const tlmGetUnrecognisedEmails = async () => {
    try {
      setLoading(true);
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/unrecognisedEmails/get",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      dispatch({ type: "DATA_RECEIVED", value: response });
      setLoading(false);
    } catch (error) {
      console.error("Error during the API call: ", error);
    }
  };
  useEffect(() => {
    tlmGetUnrecognisedEmails();
  }, []);

  useEffect(() => {
    const tlmGetLanguagesAPI = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/languages",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: {},
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();

        setLanguages(response);
      } catch (error) {
        console.error("Error during the API call:", error);
      }
    };
    tlmGetLanguagesAPI();
  }, []);

  const columns = useMemo(() => {
    return [
      {
        field: "timestamp",
        headerName: I18n.get("Date"),
        width: 200,
        editable: false,
        type: "dateTime",
        valueFormatter: (value) => {
          if (!value) {
            return ""; // Handle null or undefined values
          }
          const formattedDate = dayjs
            .utc(value)
            .tz(dayjs.tz.guess())
            .format("YYYY-MM-DD HH:mm:ss");
          return formattedDate;
        },
      },
      {
        field: "email_from",
        headerName: I18n.get("Email"),
        width: 400,
        editable: false,
      },
      {
        field: "subject",
        headerName: I18n.get("Subject"),
        width: 500,
        editable: false,
      },
      {
        field: "alarm_id",
        headerName: I18n.get("Alarm ID"),
        width: 200,
        editable: false,
      },
      {
        field: "id",
        headerName: I18n.get("Id"),
        width: 100,
        editable: false,
      },
    ];
  }, [rowModesModel]);

  const applyStoreFiltering = (value) => {
    let matchesAllFilters = true;
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      matchesAllFilters =
        matchesAllFilters &&
        Object.values(value).some((val) =>
          String(val).toLowerCase().includes(searchTextLower)
        );
    }
    return matchesAllFilters;
  };
  const filteredRows = state.audit.filter(applyStoreFiltering);
  const filteredRowsCount = filteredRows.length;

  const handleRowSelection = (ids) => {
    setSelectedRows(ids);
  };

  const searchChanged = (event) => {
    setSearchText(event.target.value);
  };

  const handleRowContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
          }
        : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
    setSelectedRows(null);
  };

  const renderToolbar = () => {
    return (
      <div ref={toolbarRef}>
         <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
            {" "}
            <Typography variant="h5" mt={0.5} mb={1}>
              {I18n.get("Unrecognized Emails")} (
              {filters ? filteredRowsCount : totalCount})
            </Typography>
            {loading && <CircularProgress size="1.5rem" />}
          </Stack>
          <Stack
            direction={tableParentIsMD ? "column" : "row"}
            alignItems="center"
            spacing={2}
            sx={{ pb: 2 }}
          >
            <Box
              sx={{
                ml: 2,
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Input
                type="text"
                placeholder={I18n.get("Search")}
                onChange={searchChanged}
                fullWidth={tableParentIsMD}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Box>
          </Stack>
      </div>
    );
  };

  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    } else if (userAgent.includes("Chrome")) {
      return "Chrome";
    }
  }
  const browser = getBrowserName();
  function getScreenDimension() {
    const screenHeight = window.screen.height;
    if (screenHeight >= 1440) {
      return "27inches";
    } else if (screenHeight >= 1080) {
      return "24inches";
    }
  }
  const screenInches = getScreenDimension();

  const [openMapDialog, setOpenMapDialog] = useState(false);
  const handleMapEmail = (value) => {
    if(value){
      setMailContent(value);
      setOpenMapDialog(true);
    }else{
      setErrorMessage(I18n.get("Please select at least one row to map an email"));
      setErrorDialogOpen(true);
    }
  };

  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [mailContent, setMailContent] = useState([]);
  const handleDisplayMail = (value) => {
    if(value){
      setMailContent(value);
      setOpenEmailDialog(true);
    } else{
      setErrorMessage(I18n.get("Please select at least one row to display the email"));
      setErrorDialogOpen(true);
    }
  };

  const handleCloseMailPopup = () => {
    setOpenEmailDialog(false);
  };

  const handleDeleteMail = async (selectedRows) => {
    if (selectedRows.length === 0) {
      setErrorMessage(I18n.get("Please select at least one row to delete the email"));
      setErrorDialogOpen(true);
      return;
    } else {
      try {
        setApiStatus({
          open: true,
          status: "pending",
          message: I18n.get("Modifying"),
        });
        const restOperation = await tlmPostDeleteUnrecognisedEmail(selectedRows);
        const response = await restOperation.response;
        if (response.statusCode === 200) {
          setLoading(true);
          setApiStatus({
            open: true,
            status: "success",
            message: I18n.get("Email successfully deleted"),
          });
          dispatch({
            type: "DATA_RECEIVED",
            value: state.audit.filter(
              (row) => row.alarm_type_id !== selectedRows
            ),
          });
          setLoading(false);
          tlmGetUnrecognisedEmails();
        } else {
          setApiStatus({
            open: true,
            status: "error",
            message: I18n.get("Failed to delete email"),
          });
        }
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
      } catch (error) {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to delete email"),
        });
        setTimeout(() => {
          setApiStatus((prevState) => ({ ...prevState, open: false }));
        }, 2000);
      }
    }
  };

  //API call to delete unrecognised emails
  const tlmPostDeleteUnrecognisedEmail = async (emailId) => {
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/unrecognisedEmails/delete",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            unrecognised_email_id: emailId, // Pass the email id that needs to be deleted
          },
        },
      });
      return restOperation;
    } catch (error) {
      throw error;
    }
  };
const [tableHeight, setTableHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const margin =
        browser === "Firefox" ? 200 : browser === "Chrome" ? 200 : 200;
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        margin;
      setTableHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const tlmPostNewSystemMap = async (formData) => {
    if(formData.rule === "email"){
      formData.search_pattern = formData.email_address;
    }else if(formData.rule === "subject"){
      formData.search_pattern = formData.word_key;
    }
    
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/systemMap/new",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: {
            search_pattern: formData.search_pattern,
            tlm_asset_id: formData.tlm_asset_id,
            rule: formData.rule,
            delay: formData.delay,
            flag: formData.flag,
          }
        },
      });
      return restOperation;
    } catch (error) {
      throw error;
    }
  };

  const handleMapEmailSubmit = async (formData) => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Mapping email"),
      });
      setOpenMapDialog(false);

      const restOperation = await tlmPostNewSystemMap(formData);
      const response = await restOperation.response;

      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Email successfully mapped"),
        });
        dispatch({
          type: "DATA_RECEIVED",
          value: state.audit.filter(
            (row) => row.id !== formData.id
          ),
        });
        tlmGetUnrecognisedEmails();
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to map email"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to map email"),
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  }
  const darkMode=localStorage.getItem("darkMode")==="true";
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
        />
        <Stack
          direction="row"
          spacing={1}
          sx={{ ml: 3, mt: 3, width: "400px" }}
        >
          <EncodingSettingsMenu />
          <PatternSettingsMenu />
          <EventHistorySettingsMenu />
        </Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
              {" "}
              {/** lasciare così */}
              <Card
                sx={{
                  p: 3,
                  maxHeight: `${tableHeight}px`,
                }}
              >
                {renderToolbar()}
                {/* <div  style={{
                    height:
                        screenInches === "27inches"
                        ? browser === "Chrome"
                        ? 985
                        : browser === "Firefox"
                        ? 970
                        : 970
                        : browser === "Chrome" //24 pollici
                        ? 625
                        : browser == "Firefox"
                        ? 605
                        : 610,
                }}> */}
                  <DataGridPro
                    sx={{
                      "& .MuiDataGrid-root, & .MuiDataGrid-footerContainer": {
                        minHeight: "2rem",
                      },
                      "&  .MuiDataGrid-cell ": {
                        cursor: "default",
                      },
                      borderColor: darkMode? "#6B635A":"",
                      "& .MuiDataGrid-cell, &.MuiDataGrid-columnHeaders": {
                        borderColor: darkMode?"#625a52":"",
                      },
                      "& .MuiDataGrid-columnSeparator": {
                        borderColor: darkMode?"#625a52":"",
                      },
                      "--DataGrid-rowBorderColor": darkMode?"#625a52":"",
                      minHeight: "20vh",
                      flexFlow: 1,
                      height: "100%",
                    }}
                    localeText={
                      language === "it"
                        ? itIT.components.MuiDataGrid.defaultProps.localeText
                        : language === "ge"
                        ? deDE.components.MuiDataGrid.defaultProps.localeText
                        : ""
                    }
                    onCellDoubleClick={(params, event) => {
                      // Prevent the default double-click behavior
                      event.defaultMuiPrevented = true;
                    }}
                    hideFooterRowCount
                    editMode="row"
                    rows={filteredRows}
                    columns={columns}
                    //disableRowSelectionOnClick
                    getRowId={(row) => row.id}
                    rowModesModel={rowModesModel}
                    onRowModesModelChange={(newModel) =>
                      setRowModesModel(newModel)
                    }
                    onRowSelectionModelChange={(newSelection) =>
                      handleRowSelection(newSelection)
                    }
                    initialState={{
                      density: "compact",
                      pinnedColumns: { right: ["actions"] },
                      columns: {
                        columnVisibilityModel: {
                          alarm_id: false,
                        },
                      },
                    }}
                    apiRef={apiRef}
                    resizeThrottleMs={resizeThrottle}
                    loading={!state.fetched || resizeThrottle > 60}
                    onProcessRowUpdateError={(error) => console.log({ error })}
                    //columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={handleColumnVisibilityChange}
                    onSelectionModelChange={(newSelection) => {
                      const selectedRows = newSelection.map((id) =>
                        filteredRows.find((row) => row.id === id)
                      );
                      //setSelectedRows(selectedRows);
                    }}
                    slotProps={{
                      loadingOverlay: {
                        variant: "skeleton",
                        noRowsVariant: "skeleton",
                      },
                      row: {
                        onContextMenu: (e) => handleRowContextMenu(e),
                      },
                    }}
                    slots={{
                      toolbar: () => (
                        <GridToolbarContainer>
                          <GridToolbarColumnsButton />
                          <GridToolbarExport
                            printOptions={{ disableToolbarButton: true }}
                            csvOptions={{
                              fileName: "Unrecognized Emails",
                              utf8WithBom: true,
                            }}
                          />
                          <GridToolbarFilterButton />
                        </GridToolbarContainer>
                      ),
                    }}
                  />
                  <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                    }
                  >
                <MenuItem
                  onClick={() => {
                    const selectedRow = Array.from(apiRef.current.getSelectedRows().values())[0];
                    handleDisplayMail(selectedRow);
                    handleClose();
                  }}
                  style={{ fontSize: "18px" }}
                >
                  <EmailRounded style={{ marginRight: 8 }} />
                  {I18n.get("Display email")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const selectedRowIds = Array.from(apiRef.current.getSelectedRows().keys());
                    handleDeleteMail(selectedRowIds);
                    handleClose();
                  }}
                  style={{ fontSize: "18px" }}
                >
                  <DeleteIcon style={{ marginRight: 8 }} />
                  {I18n.get("Delete email")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const selectedRow = Array.from(apiRef.current.getSelectedRows().values())[0];
                    handleMapEmail(selectedRow);
                    handleClose();
                  }}
                  style={{ fontSize: "18px" }}
                >
                  <AddCircleIcon style={{ marginRight: 8 }} />
                  {I18n.get("Map email")}
                </MenuItem>
              </Menu>

              {openEmailDialog && (
                <UnrecMailPopup
                  isOpen={openEmailDialog}
                  onClose={handleCloseMailPopup}
                  email={mailContent}
                />
              )}
              {openMapDialog && (
                <MapEmailPopup 
                  isOpen={openMapDialog}
                  onClose={() => setOpenMapDialog(false)}
                  email={mailContent}
                  handleMapEmailSubmit={handleMapEmailSubmit}
                />)}

                  <ErrorDialog
                    open={errorDialogOpen}
                    onClose={() => setErrorDialogOpen(false)}
                    message={errorMessage}
                  />
                  <APIStatusDialog
                    open={apiStatus.open}
                    status={apiStatus.status}
                    message={apiStatus.message}
                  />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </DashboardLayout>
    </>
  );
}

export default UnrecognizedEmail;
